export default __webpack_public_path__ + "static/media/letterClock.8543b256.png";